function isContextualEmail(email) {
    return email.endsWith("@getcontextual.io");
}

export { isContextualEmail };
//# sourceMappingURL=contextual.js.map
